import React from "react"
import { Id, OperationsContainer, OrderLineInfo, Reason } from "./Shared.styled"
import { OrderRefund } from "lib/types/generated/graphql-types"
import Money from "../../../Money"
import DineroFactory from "dinero.js"
import { useOrderTabContext } from "../../../../views/Orders/OrderViews/OrderTabContext"

type Props = {
  refund: OrderRefund
  currencyCode: string
  orderLineId: string
}

const RefundInfo = ({ refund, currencyCode, orderLineId }: Props) => {
  const { switchToUpdatesTab } = useOrderTabContext()

  const refundedOrderLine = refund?.orderLines?.find(
    (ol) => ol.orderLineId === orderLineId)



  return (
    <OperationsContainer>
      <div>
        <b>Refund</b>{" "}
        <div>
          {refund?.reason && (<Reason>{refund?.reason?.code} - {refund?.reason?.cause}</Reason>)}
        </div>{" "}
        <Id onClick={switchToUpdatesTab}>{refund.id}</Id>
      </div>{" "}
      <div>
        <OrderLineInfo>
          <div>Quantity:</div>
          <div>
            {refundedOrderLine?.quantity}
          </div>
        </OrderLineInfo>
        <OrderLineInfo>
          <div>Refund payment:</div>
          <div>
            {"-"}
            <Money
              amount={refundedOrderLine?.totalAmount ?? 0}
              currencyUnit={currencyCode as DineroFactory.Currency}
            />
          </div>
        </OrderLineInfo>
      </div>
    </OperationsContainer>
  )
}

export default RefundInfo
